export const ROLE_LABEL = {
  admin: "Admin",
  lead: "Lead",
  staff: "Staff",
  management: "Read Only",
  kiosk: "Kiosk",
  maintenance: "Maintenance",
};

export const roleLabel = (role) => ROLE_LABEL[role] || role;
